<template>
  <z-form ref="form" tag="div" @submit.native.prevent="submit">
    <form class="row">
      <z-form-input class="col-8" :rules="{ required: true }" mode="passive_aggressive">
        <i-select v-model="internal_account_id">
          <i-option
            v-for="sip in internal_accounts"
            :key="sip.id"
            :label="sip.format_name"
            :value="sip.id"
          />
        </i-select>
      </z-form-input>
      <div class="col-4">
        <i-button type="primary" html-type="submit" :long="true" :loading="is_loading">
          {{ $t('shared.component.button.add') }}
        </i-button>
      </div>
    </form>
  </z-form>
</template>

<script>
  import { SipAccountService } from '@pbx/services/SipAccountService';
  import { isInternal } from '@pbx/helpers/contact-methods';

  export default {
    props: {
      exist: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        internal_account_id: null,
        is_loading: false,
        free_internal_accounts: []
      };
    },

    computed: {
      exist_internal_accounts: function() {
        return this.exist.filter(account => isInternal(account));
      },

      internal_accounts: function() {
        /** Возвращаем только те аккаунты. которые еще не добавлены в список */
        return this.free_internal_accounts.filter(item => !this.is_exist(item.id));
      }
    },

    created() {
      SipAccountService.getFreeInternalsOnlySelect().then(
        res => (this.free_internal_accounts = res)
      );
    },

    methods: {
      get_contact_method(id) {
        const method = this.internal_accounts.find(source => source.id === id);
        return { ...method, sip_account_id: id };
      },

      is_exist: function(id) {
        const exist_ids = this.exist_internal_accounts.map(i => i.id);
        return exist_ids.includes(id);
      },

      submit: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const id = this.internal_account_id;
            this.is_loading = true;
            this.internal_account_id = null;
            this.$refs.form.reset();

            const contact_method = this.get_contact_method(id);
            this.$emit('on-add', contact_method);
            this.is_loading = false;
          }
        });
      }
    }
  };
</script>
